import React, { useState, useRef, useEffect } from 'react';
import VideoDocPopup from './VideoDocPopup';
import HelpdeskApiCall from 'HelpdeskApiCall';


const VideoDocumentation = ({ isActive, isDisabled, onClick }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [moduleData, setModuleData] = useState({});
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const toggleButtonRef = useRef(null);


  const openPopup = () => setIsPopupOpen(true);
  const closePopup = () => setIsPopupOpen(false);

  useEffect(() => {
    apiCallToGetVideoData();
  }, [])

  const apiCallToGetVideoData = async () => {
    let requestData = {
      moduleId: 11,

    };

    let jsonResponse = await HelpdeskApiCall.makeApiCall(
      'HelpDeskGetModuleWiseDemoPointList',
      requestData,
      "/api/helpDesk/documentationPublicData.php"
    );

    if (jsonResponse.expired) {

      setTimeout(() => {
        apiCallToGetVideoData()
      }, 1000);
    } else {
      if (jsonResponse.success) {
        setModuleData(jsonResponse.APIResult.data['11']?.subModuleData)
      } else {

        // toast.error("Something went wrong while getting Video Documentation Data. Please try again later.")
      }
    }
  }


  const togglePopup = () => {
    onClick?.();
    setIsPopupOpen(prev => !prev);
  };

  return (
    <>
      <div
        style={{
          position: 'relative',
          display: 'inline-block',

        }}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      // ref={toggleButtonRef}

      >
        {showTooltip && (
          <div
            style={{
              position: 'absolute',
              top: '50%',
              right: '110%',
              transform: 'translateY(-50%)',
              backgroundColor: 'black',
              color: 'white',
              padding: '6px 10px',
              borderRadius: '5px',
              fontSize: '12px',
              whiteSpace: 'nowrap',
              zIndex: 999,
            }}
          >
            Video Documentation
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '100%',
                transform: 'translateY(-50%)',
                width: 0,
                height: 0,
                borderTop: '6px solid transparent',
                borderBottom: '6px solid transparent',
                borderLeft: '6px solid black',
              }}
            />
          </div>
        )}
        <button
          onClick={togglePopup}
          style={{
            color: 'white',
            backgroundColor: 'white',
            border: 'none',
            cursor: 'pointer',
            opacity: isDisabled ? 0.4 : 1
          }}
        >
          <img src={`${process.env.PUBLIC_URL}/assets/images/video.svg`} alt="video" style={{ width: 18, height: 18 }} />
        </button>
      </div>
      <VideoDocPopup isOpen={isPopupOpen} onClose={() => togglePopup()} ignoreRef={toggleButtonRef} moduleData={moduleData} />
      {/* <ToastContainer theme="light" /> */}

    </>
  );
};

export default VideoDocumentation;